"use strict";
exports.__esModule = true;
exports.OPTIONS = exports.TRANSLATIONS = exports.INFO = void 0;
var Dom = require("./dom");
var english_1 = require("./translate/english");
var halfmoon = require("halfmoon");
var params_1 = require("./params");
exports.TRANSLATIONS = english_1.English;
var optionsKey = "CenterBrainArchiveOptions";
var savedOptions = localStorage.getItem(optionsKey);
if (savedOptions != null) {
    exports.OPTIONS = JSON.parse(savedOptions);
}
else {
    exports.OPTIONS = {
        displayUsageLinks: true,
        savedRecipes: [],
    };
}
;
window.addEventListener("load", halfmoon.onDOMContentLoaded);
window.addEventListener("visibilitychange", function (ev) {
    localStorage.setItem(optionsKey, JSON.stringify(exports.OPTIONS));
});
fetch('dsp.json')
    .then(function (r) { return r.json(); })
    .then(function (data) {
    exports.INFO = data;
    console.log(exports.INFO);
    var content = document.getElementById('content');
    var updater = function () {
        var newContent;
        var params = params_1.getParams();
        if (params === null) {
            newContent = Dom.makeLanding();
        }
        else if (params.action == "consumption") {
            newContent = Dom.makeConsumeItem(params.item);
        }
        else if (params.action == "production") {
            newContent = Dom.makeProduceItem(params.item);
        }
        else if (params.action == "showPins") {
            newContent = Dom.makeViewPins();
        }
        else {
            newContent = Dom.makeLanding();
        }
        content.innerHTML = "";
        content.appendChild(newContent);
    };
    window.addEventListener('hashchange', updater);
    // and call it to start up!
    updater();
    Dom.updatePins();
    var usageLinkToggle = document.getElementById('usage-links');
    usageLinkToggle.checked = exports.OPTIONS.displayUsageLinks;
    usageLinkToggle.onclick = function (ev) {
        exports.OPTIONS.displayUsageLinks = usageLinkToggle.checked;
        updater();
        Dom.updatePins();
    };
    var sidebarToggle = document.getElementById('toggle-sidebar-btn');
    sidebarToggle.onclick = function () {
        halfmoon.toggleSidebar();
    };
    document.getElementById('sidebar-title').innerText = exports.TRANSLATIONS.other.pinnedRecipes;
});
